import { render, staticRenderFns } from "./textModal.vue?vue&type=template&id=6d41549d&scoped=true&"
import script from "./textModal.vue?vue&type=script&lang=js&"
export * from "./textModal.vue?vue&type=script&lang=js&"
import style0 from "./textModal.vue?vue&type=style&index=0&id=6d41549d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d41549d",
  null
  
)

export default component.exports